import React from "react";
import { Breadcrumbs, Typography, Box, Container } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserSecret,
  faUserTie,
  faChalkboardTeacher,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const navLinks = [
  {
    key: "TpAdmins",
    label: "Admins",
    to: "/TpAdmins",
    icon: faUserSecret,
    color: "#f44336",
  },
  {
    key: "TpCoordinators",
    label: "Coordinators",
    to: "/TpCoordinators",
    icon: faUserTie,
    color: "#2196f3",
  },
  {
    key: "TpInstructors",
    label: "Instructors",
    to: "/TpInstructors",
    icon: faChalkboardTeacher,
    color: "#4caf50",
  },
  {
    key: "TpStaff",
    label: "Staff",
    to: "/TpStaff",
    icon: faUsers,
    color: "#ff9800",
  },
];

// Lets Admins/Coordinators/Instructors/Staff pages jump directly to one
// another without opening the left nav drawer.
const TpUserMgtBreadCrumbs = ({ pageName }) => {
  const theme = useTheme();
  const location = useLocation();

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Box
        sx={{
          backgroundColor:
            theme.components.MuiBreadcrumbs.styleOverrides.root.backgroundColor,
          color: theme.components.MuiBreadcrumbs.styleOverrides.root.color,
          padding: "20px",
          marginBottom: "20px",
          borderRadius: "10px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
        }}
      >
        <Box>
          <Breadcrumbs maxItems={10} separator="•" aria-label="breadcrumb">
            {navLinks.map((link) => {
              const isActive =
                location.pathname.toLowerCase() === link.to.toLowerCase();
              return (
                <Link
                  key={link.key}
                  to={link.to}
                  style={{
                    color: "#ffffff",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    fontWeight: isActive ? 700 : 400,
                    textDecoration: isActive ? "underline" : "none",
                  }}
                >
                  <FontAwesomeIcon icon={link.icon} style={{ color: link.color }} />
                  {link.label}
                </Link>
              );
            })}
          </Breadcrumbs>
          {pageName && (
            <Typography
              variant="h5"
              fontWeight="bold"
              style={{ color: "#ffffff" }}
            >
              {pageName}
            </Typography>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default TpUserMgtBreadCrumbs;
